export const STATUS_LABELS = {
    NEW: 'Nuevo',
    OPEN: 'Abierto',
    IN_PROGRESS: 'En progreso',
    PENDING_CUSTOMER: 'Espera cliente',
    PENDING_THIRD_PARTY: 'Espera tercero',
    RESOLVED: 'Resuelto',
    CLOSED: 'Cerrado',
    CANCELLED: 'Cancelado',
};

export const PRIORITY_LABELS = {
    LOW: 'Baja',
    MEDIUM: 'Media',
    HIGH: 'Alta',
    URGENT: 'Urgente',
    CRITICAL: 'Crítica',
};

export const TYPE_LABELS = {
    INCIDENT: 'Incidente',
    REQUEST: 'Solicitud',
    PROBLEM: 'Problema',
    CHANGE: 'Cambio',
    TASK: 'Tarea',
};

export const QUICK_RANGE_OPTIONS = [7, 15, 30, 60, 90].map((value) => ({
    value,
    label: `Últimos ${value} días`,
}));

export const createEmptyDashboard = () => ({
    summary: {
        customers: 0,
        projects: 0,
        groups: 0,
        tickets: 0,
        openTickets: 0,
        closedTickets: 0,
    },
    tickets: {
        byStatus: [],
        byPriority: [],
        byType: [],
        createdTrend: [],
        topProjects: [],
    },
    previousSummary: {
        tickets: 0,
        openTickets: 0,
        closedTickets: 0,
    },
});
